import { Heading, Paragraph } from "../../../atoms";
import { Box, Flex } from "../../../cores";
import { useViewContext } from "../../../hooks";
import { IconColoredNumberOneToFive } from "../../../icons";

interface IFolksamResultDescription {
  descriptionTitle: string;
  descriptionText: Array<string>;
}

const FolksamResultDescription = ({
  descriptionTitle,
  descriptionText,
}: IFolksamResultDescription) => {
  const { isMobile } = useViewContext();

  return (
    <Box
      sx={{
        width: ["100%", null, null, "50%", "50%"],
        "> div": {
          marginY: 10,
          "> p": {
            marginLeft: "sm",
            fontSize: ["xs", null, "16px", null, null],
          },
        },
      }}
    >
      <Heading as={"h4"} variant={!isMobile ? "h5" : "h6"}>
        {descriptionTitle}
      </Heading>
      <Flex>
        <IconColoredNumberOneToFive value={"5"} />
        <Paragraph>{descriptionText[4]}</Paragraph>
      </Flex>
      <Flex>
        <IconColoredNumberOneToFive value={"4"} />
        <Paragraph>{descriptionText[3]}</Paragraph>
      </Flex>
      <Flex>
        <IconColoredNumberOneToFive value={"3"} />
        <Paragraph>{descriptionText[2]}</Paragraph>
      </Flex>
      <Flex>
        <IconColoredNumberOneToFive value={"2"} />
        <Paragraph>{descriptionText[1]}</Paragraph>
      </Flex>
      <Flex>
        <IconColoredNumberOneToFive value={"1"} />
        <Paragraph>{descriptionText[0]}</Paragraph>
      </Flex>
    </Box>
  );
};

export default FolksamResultDescription;
